import { render, staticRenderFns } from "./composition-players-list.vue?vue&type=template&id=203833ff&scoped=true&"
import script from "./composition-players-list.vue?vue&type=script&lang=js&"
export * from "./composition-players-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203833ff",
  null
  
)

export default component.exports